import React, { memo } from "react";
import { Stack } from "investira.react.components";
// import SegmentoAnalytics from "./SegmentoAnalytics";
import Concentracao from "../Concentracao";

const Segmentos = memo((props) => {
  const { segmentos, detalhe, variant } = props;
  return (
    <Stack spacing={4}>
      <Concentracao segmentos={segmentos} detalhe={detalhe} variant={variant} />
    </Stack>
  );
});

export default Segmentos;
